export const basicModel = {
    first_name: null,
    last_name: null,
    birthday: null,
    email: null,
    document: null,
    document_individual: null,
    password: null,
    corfirm_password: null,
    institution_id: null,
    phone: null,
    zipcode: null,
    country: null,
    address: null,
    address_number: null,
    address_complements: null,
    address_neighbour: null,
    address_city: null,
    picture: null,
    state: null,
    login_by: 'manual',
};

export const vehicleModel = {
    provider_type: [],
    car_number: null,
    car_brand: null,
    car_model: null,
};

export const bankModel = {
    holder: null,
    bank_id: null,
    agency: null,
    account: null,
    document_individual: null,
    account_digit: null,
    person_type: "individual",
    account_type: null,
    birthday_date: null,
};

export const pixModel = {
    pix: null,
    cnpj:null,
    invalidCNPJ:false
};


export const documentsModel = {
    docs: [],
};

//supose hould be enum
export const pixKeys = {
    PIX_EMAIL:  'email_key',
    PIX_PHONE:  'phone_key',
    PIX_CPF:    'cpf_key',
    PIX_CNPJ:   'cnpj_key'
};
